import { render, staticRenderFns } from "./auth-group-add.vue?vue&type=template&id=5e6def5e"
import script from "./auth-group-add.vue?vue&type=script&lang=js"
export * from "./auth-group-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports